/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Staatsexamen_Lehramt24Inputs */

const en__field_enum_icsrm_staatsexamen_lehramt24 = /** @type {(inputs: _Field_Enum_Icsrm_Staatsexamen_Lehramt24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

const de__field_enum_icsrm_staatsexamen_lehramt24 = /** @type {(inputs: _Field_Enum_Icsrm_Staatsexamen_Lehramt24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Lehramt`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Lehramt" |
*
* @param {_Field_Enum_Icsrm_Staatsexamen_Lehramt24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_staatsexamen_lehramt24 = /** @type {((inputs?: _Field_Enum_Icsrm_Staatsexamen_Lehramt24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Staatsexamen_Lehramt24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_staatsexamen_lehramt24(inputs)
	return de__field_enum_icsrm_staatsexamen_lehramt24(inputs)
});
export { _field_enum_icsrm_staatsexamen_lehramt24 as "_field_enum_ICSRM_STAATSEXAMEN_LEHRAMT" }